import { TFunction } from 'i18next';

export const getQuestions = (t: TFunction) => {
  return t('pricingPage.faq.questions', { returnObjects: true }) as Array<{
    question: string;
    answer: string;
  }>;
};
